import { type FlowListName } from '@/components/Wizard';

export const GTM_FORM_NAME = 'registry360';

export const GTM_EVENTS = {
  formStart: 'form_start',
  stepView: 'step_view',
  stepComplete: 'step_complete',
  fieldError: 'field_error',
  validationError: 'validation_error',
  verificationResult: 'verification_result'
} as const;

export type GtmFlow = 'pf' | 'pj_socio' | 'pj_procurador';

export const FLOW_LIST_TO_GTM_FLOW: Partial<Record<FlowListName, GtmFlow>> = {
  'natural-person': 'pf',
  'legal-entity-partner-validated': 'pj_socio',
  'legal-entity-representative': 'pj_procurador'
};

export const FORM_START_STEPS = new Set(['document-not-found-capture', 'face-detection', 'legal-entity-relation']);

export const UNDEFINED_FLOW_STEPS = new Set(['document-not-found-capture', 'legal-entity-relation']);

export const EXCLUDED_FLOW_LISTS = new Set<FlowListName>(['loading', 'error']);

export const EXCLUDED_STEPS = new Set(['loading', 'error']);

export const CONTINUATION_STEPS = new Set(['the-end']);

export const FORM_START_STORAGE_PREFIX = 'registry360:gtm:form_start:';

export const ANONYMOUS_USER_ID = 'anonymous';
